import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';

class ConservazioneConfermaController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ArchiSmallServices',
        '$timeout',
        '$uibModalStack',
        '$state',
        'store'
    ];

    private close: any;
    private dismiss: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService,
        private $uibModalStack: ng.ui.bootstrap.IModalStackService,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService
    ) {
        $scope.updateInProgress = true;
        ArchiSmallServices.enableConservazione($rootScope.user)
            .then((response) => {
                $timeout(() => {
                    $rootScope.user = response;
                    store.set('user', response);
                    $scope.updateInProgress = false;
                }, 2000);
            }, (error) => {
                $rootScope.alert('error', error);

            });
        $scope.selected = {
        };
        $scope.ok = () => {
            $state.go('home.conservazione');
            this.close();
        };
        $scope.cancel = () => {
            this.dismiss({ $value: 'cancel' });
        };
    }
}

export const ConservazioneConfermaComponent: ng.IComponentOptions = {
    template: require('./conservazione-conferma.html'),
    controller: ConservazioneConfermaController,
    bindings: {
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/conservazione-conferma/conservazione-conferma.ts